import React from 'react';

import modal from './modal';

import DMForm from '../DMForm';

function formInModal(f) {
	let m = {
		id: f.id,
		className: f.className,
		close: f.close,
		dontAllowClose: f.dontAllowClose,
		footer: f.footer,
		header: f.header,
		noFooter: true,
		onClose: f.onClose,
	};

	let form = f.form;

	form.inModal = true;

	form.closeButton = modal.close.bind(this, f.id);

	m.body = <DMForm form={form} />;

	modal(m);
}

formInModal.close = (i) => {
	modal.close(i);
};

export default formInModal;
